import React from 'react';
import { UserProfile } from '../../types/advanced-retirement';

interface SavedRRSPScenario {
  id: string;
  name: string;
  data: any;
  createdAt: string;
}

interface GeneralSettingsSectionProps {
  userProfile: UserProfile;
  handleInputChange: (field: keyof UserProfile, value: any) => void;
  savedScenarios?: SavedRRSPScenario[];
  onLoadScenario?: (id: string) => void;
  onDeleteScenario?: (id: string) => void;
}

const GeneralSettingsSection: React.FC<GeneralSettingsSectionProps> = ({
  userProfile,
  handleInputChange,
  savedScenarios = [],
  onLoadScenario,
  onDeleteScenario
}) => {
  return (
    <div className="form-section">
      {/* Saved Scenarios Section */}
      {savedScenarios.length > 0 && (
        <div className="retirement-scenarios-section" style={{
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: 12,
          padding: '16px',
          marginBottom: '24px'
        }}>
          <div className="scenarios-header" style={{ marginBottom: '16px' }}>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#374151' }}>📋 Your Saved Retirement Scenarios</h3>
          </div>
          <div style={{ display: 'grid', gap: '12px' }}>
            {savedScenarios.map(scenario => (
              <div key={scenario.id} style={{
                display: 'flex',
                gap: '12px',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '12px 16px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <span style={{ fontWeight: 600, fontSize: '1rem', color: '#111827' }}>{scenario.name}</span>
                  <span style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '2px' }}>
                    {new Date(scenario.createdAt).toLocaleString()}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {onLoadScenario && (
                    <button
                      className="sidebar-btn"
                      onClick={() => onLoadScenario(scenario.id)}
                      style={{ padding: '8px 16px', fontSize: '0.9rem', background: 'var(--info-500)', color: 'var(--text-on-info)', border: 'none', borderRadius: '6px' }}
                    >
                      📂 Load Scenario
                    </button>
                  )}
                  {onDeleteScenario && (
                    <button
                      className="sidebar-btn"
                      onClick={() => onDeleteScenario(scenario.id)}
                      style={{ padding: '8px 16px', fontSize: '0.9rem', background: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '6px' }}
                    >
                      🗑️ Delete
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <h3>General Settings</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>Current Year</label>
          <input
            type="number"
            value={userProfile.currentYear}
            onChange={(e) => handleInputChange('currentYear', parseInt(e.target.value))}
          />
        </div>
        <div className="form-group">
          <label>Province</label>
          <select
            value={userProfile.province}
            onChange={(e) => handleInputChange('province', e.target.value)}
          >
            <option value="Ontario">Ontario</option>
            <option value="Quebec">Quebec</option>
            <option value="British Columbia">British Columbia</option>
            <option value="Alberta">Alberta</option>
            <option value="Manitoba">Manitoba</option>
            <option value="Saskatchewan">Saskatchewan</option>
            <option value="Nova Scotia">Nova Scotia</option>
            <option value="New Brunswick">New Brunswick</option>
            <option value="Newfoundland and Labrador">Newfoundland and Labrador</option>
            <option value="Prince Edward Island">Prince Edward Island</option>
            <option value="Northwest Territories">Northwest Territories</option>
            <option value="Yukon">Yukon</option>
            <option value="Nunavut">Nunavut</option>
          </select>
        </div>
        <div className="form-group">
          <label>Marital Status</label>
          <select
            value={userProfile.maritalStatus || 'Single'}
            onChange={(e) => handleInputChange('maritalStatus', e.target.value)}
          >
            <option value="Single">Single</option>
            <option value="Married/Common-law">Married/Common-law</option>
          </select>
        </div>
        {(userProfile.maritalStatus === 'Married/Common-law') && (
          <div className="form-group">
            <label>Enable Income Splitting</label>
            <input
              type="checkbox"
              checked={userProfile.enableIncomeSplitting || false}
              onChange={(e) => handleInputChange('enableIncomeSplitting', e.target.checked)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralSettingsSection; 